export const getIconColor = (isDisabled: boolean) =>
    isDisabled ? 'grey-500' : 'white';
